import css from "standard/css";

const style = css`
.modal {
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
}

.modal[opened="false"] {
  display: none;
}

.modal[opened="true"] {
  display: flex;
}

.modal__container {
  background-color: white;
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-level-2);
  display: flex;
  flex-direction: column;
  padding: var(--spacing_inset-sm);
  position: relative;
  width: 460px;
}

.modal__header {
  display: flex;
  align-items: center;
  gap: var(--spacing_inset-xs);
  padding: var(--spacing_inset-xs);
}

.modal__img {
  aspect-ratio: 1 / 1;
  background-color: var(--color-master-lightest);
  border-radius: var(--border-radius-circular);
  color: transparent;
  height: 72px;
  text-indent: -999px;
  width: 72px;
}

.modal__hgroup {
  color: var(--color-master-dark);
  display: flex;
  flex-direction: column;
  font-family: var(--font-family-highlight);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-sm);

  h1 {
    font-size: var(--font-size-md);
  }

  h2 {
    font-size: var(--font-size-xxs);
  }
}

.modal__main {
  display: flex;
  flex-direction: column;
  gap: var(--spacing_inset-md);
  padding: var(--spacing_inset-xs);
}

.modal__section {
  display: flex;
  gap: var(--spacing_inset-nano);
  flex-direction: column;
}

.modal__strong {
  color: var(--color-master-dark);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-xs);
  line-height: var(--line-height-lg);
}

.modal__span {
  color: var(--color-master);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xxs);
  line-height: var(--line-height-lg);
}

.modal__ul {
  display: flex;
  gap: var(--spacing_inset-xs);
  list-style: none;
}

.modal__li {
  background-color: var(--color-master-lighter);
  color: var(--color-master);
  cursor: pointer;
  display: flex;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-xxs);
  justify-content: center;
  line-height: var(--line-height-lg);
  padding: var(--spacing_inset-quarck) var(--spacing_inset-xs);
  border-radius: var(--border-radius-sm);
  width: 100%;
}

.modal__li[checked=true] {
  background-color: var(--color-complete);
  color: var(--color-master-lightest);
}

.modal__footer {
  padding: var(--spacing_inset-xs);
  padding-top: var(--spacing_inset-sm);
}

.modal__save {
  align-items: center;
  background-color: #FB601D;
  border: none;
  border-bottom: 2px solid #ff7d45;
  border-radius: 12px;
  box-shadow: 0 10px 0 #cd511c;
  color: var(--color-pure-white);
  cursor: pointer;
  display: flex;
  font-family: var(--font-family-highlight);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  gap: var(--spacing-nano);
  height: 50px;
  justify-content: center;
  line-height: 1;
  padding: 0 var(--spacing_inset-md);
  width: 100%;
}

.modal__save:active {
  box-shadow: none; 
  transform: translateY(5px);
}
`;

export default style;
